import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StaticDataService } from './static-data.service';
import { of, Subject } from 'rxjs';
import { Config } from '../config/config';
import { tap } from 'rxjs/operators';
export class RestDataService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this.pageSize = 10;
        this.options = StaticDataService.options;
        this.isAuthorIdEnabled = false;
        this.subject = new Subject();
        this.videoCaptionAdd = new Subject();
        this.videoImageCaptionAdd = new Subject();
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        this.options2 = {
            headers: this.headers
        };
        this.cached = {};
        const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
        const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
        if (conf && domain) {
            const domainConfig = JSON.parse(conf)[domain];
            this.isAuthorIdEnabled = (domainConfig && domainConfig['config']
                && domainConfig['config']['story'] && domainConfig['config']['story']['authorId']
                && domainConfig['config']['story']['authorId'] === 'true');
        }
        else {
            const domainConfig = StaticDataService.defaultConfig;
            this.isAuthorIdEnabled = !!(domainConfig && domainConfig['config']
                && domainConfig['config']['story'] && domainConfig['config']['story']['authorId']
                && domainConfig['config']['story']['authorId'] === 'true');
        }
    }
    http_tag(uuid, headline, summary, body, callback) {
        const Formbody = new URLSearchParams();
        Formbody.set('headline', String(headline));
        Formbody.set('summary', String(summary));
        Formbody.set('body', String(body));
        // console.log('get tags -> ' + this.config.get('product').tagsUrl + '/getTags?uuid=' + uuid);
        return this.http.post(this.config.get('product').tagsUrl + '/getTags?uuid=' + uuid, JSON.stringify({
            heading: headline,
            summary: summary,
            body: body
        }), this.options2)
            .subscribe(user => {
            // console.log(user);
            callback(user);
        });
    }
    http_get(url) {
        //  console.log('get -> ' + url);
        // this.cached[url] = null;
        // const cachedResponse = this.cacheservice.get(url) || null;
        // console.log(url.indexOf('meta') && this.cached[url]);
        // if (url.indexOf('meta') > -1) {
        //   console.log('response from cache');
        //   // console.log(cachedResponse);
        //   return Observable.of(this.cached[url] || null);
        // }
        // console.log(this.cached.hasOwnProperty(url));
        // console.log('is flag ', this.isAuthorIdEnabled);
        let cache = JSON.parse(localStorage.getItem(StaticDataService.cacheLiteral));
        // url (.*):(\d*)\/?
        if (cache && cache.hasOwnProperty(url) && cache[url] && this.cached[url] !== null) {
            // console.log('response from cache');
            return of(this.cached[url]);
        }
        else {
            if (cache === null) {
                cache = {};
            }
            return this.http.get(url).pipe(tap(event => {
                // console.log('response from server');
                // console.log(event);
                // this.cacheservice.put(url, event);
                // if (url.indexOf('/api/public/domain/all') > -1) {
                //   cache[url] = event;
                //   localStorage.setItem(StaticDataService.cacheLiteral , JSON.stringify(cache));
                // }
                return event;
            }, err => {
                console.log(err);
            }));
        }
    }
    http_post(url, jsondata, callback) {
        // console.log('post -> ' + url);
        this.http.post(url, JSON.stringify(jsondata ? jsondata : {}), this.options).subscribe(res => {
            callback(res);
        }, error => {
            console.log(error);
            if (error.status === 200) {
                callback(error);
            }
            else {
                callback({
                    error: error.error,
                    status: error.status
                });
            }
        });
    }
    http_put(url, jsondata, callback) {
        // console.log('put -> ' + url);
        this.http.put(url, JSON.stringify(jsondata ? jsondata : {}), this.options).subscribe(res => {
            callback(res);
        }, error => {
            callback(error);
            console.log(error);
        });
    }
    http_delete(url, jsondata, callback) {
        // console.log('delete -> ' + url);
        // this.http.delete(url,
        //   JSON.stringify( jsondata ? jsondata : {}),
        //   this.options
        //   )
        // .subscribe(
        //   res => {
        //     callback(res);
        //   },
        //   error => {
        //     console.log(error);
        //   }
        //   );
        this.http.request('delete', url, { body: (jsondata ? jsondata : {}) })
            .subscribe(res => {
            // console.log(res);
            callback(res);
        }, error => {
            console.log(error);
            callback(error);
        });
    }
    tokenParse() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
            if (!!token['access_token']) {
                token = token['access_token'];
                token = JSON.parse(atob(token.split('.')[1]));
                console.log("USER TOKEN", token.user);
                return this.userDetail = token.user;
            }
        });
    }
    http_get_options(url, options) {
        let cache = JSON.parse(localStorage.getItem(StaticDataService.cacheLiteral));
        if (cache && cache.hasOwnProperty(url) && cache[url] && this.cached[url] !== null) {
            return of(this.cached[url]);
        }
        else {
            if (cache === null) {
                cache = {};
            }
            return this.http.get(url, options).pipe(tap(event => {
                return event;
            }, err => {
                console.log(err);
            }));
        }
    }
}
